<lib-app-header
  [appTitle]="title"
  [appTitleShort]="title"
  [userName]="userName"
  [aisUrl]="aisUrl"
  [actions]="headerActions"
  [shadow]=false
  [httpParams]="httpParams"
  [red]="red"
  [translate]="translate"
></lib-app-header>

<div *ngIf="isMobile()" style="margin-top: 64px;">
    <mat-toolbar class="ms-0 ps-0" style="position: relative;">
        <button mat-icon-button (click)="sidenav.toggle()" style="z-index: 1000;">
            <mat-icon style="color: blue;">menu</mat-icon>
        </button>
        <span
            class="fs-5"
            style="
        position: absolute;
        left: 0;
        right: 0;
        text-align: center;
        white-space: normal;
        overflow-wrap: anywhere;
        padding: 0 56px;
        line-height: 1.2;
      "
        >
      {{activeTabTitle | translate}}
    </span>
    </mat-toolbar>
</div>

<mat-sidenav-container class="sidenav-container">

    <!-- Sidebar -->
    <mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="!isMobile()" [autoFocus]="false">

        <mat-nav-list>
            <a mat-list-item [routerLink]="['/predmety']" queryParamsHandling="preserve" routerLinkActive="active-link" tabindex="0">
                <mat-icon class="me-2" matListItemIcon>menu_book</mat-icon>
                @if (isMobile()) {
                    <div matListItemTitle (click)="sidenav.close()" i18n
                         class="d-flex align-items-center justify-content-start">Predmety</div>
                } @else {
                    <div matListItemTitle i18n class="d-flex align-items-center">Predmety</div>
                }
            </a>

            <mat-divider></mat-divider>

            <a mat-list-item [routerLink]="['/skusky']" queryParamsHandling="preserve" routerLinkActive="active-link" tabindex="0">
                <mat-icon class="me-2" matListItemIcon>rule</mat-icon>
                @if (isMobile()) {
                    <div matListItemTitle (click)="sidenav.close()" i18n
                         class="d-flex align-items-center justify-content-start">Skúšky</div>
                } @else {
                    <div matListItemTitle i18n class="d-flex align-items-center">Skúšky</div>
                }
            </a>

            <mat-divider></mat-divider>

            <a mat-list-item [routerLink]="['/hodnotenia-priebezne']" queryParamsHandling="preserve" routerLinkActive="active-link" tabindex="0">
                <mat-icon class="me-2" matListItemIcon>published_with_changes</mat-icon>
                @if (isMobile()) {
                    <div matListItemTitle (click)="sidenav.close()" i18n
                         class="d-flex align-items-center justify-content-start">Priebežné hodnotenie</div>
                } @else {
                    <div matListItemTitle i18n class="d-flex align-items-center">Priebežné hodnotenie</div>
                }
            </a>

            <mat-divider></mat-divider>

            <a mat-list-item [routerLink]="['/prehlady']" queryParamsHandling="preserve" routerLinkActive="active-link" tabindex="0">
                <mat-icon class="me-2" matListItemIcon>analytics</mat-icon>
                @if (isMobile()) {
                    <div matListItemTitle (click)="sidenav.close()" i18n
                         class="d-flex align-items-center justify-content-start">Prehľady</div>
                } @else {
                    <div matListItemTitle i18n class="d-flex align-items-center">Prehľady</div>
                }
            </a>

            <mat-divider></mat-divider>

            <a mat-list-item [routerLink]="['/harmonogram']" queryParamsHandling="preserve" routerLinkActive="active-link" tabindex="0">
                <mat-icon class="me-2" matListItemIcon>pending_actions</mat-icon>
                @if (isMobile()) {
                    <div matListItemTitle (click)="sidenav.close()" i18n
                         class="d-flex align-items-center justify-content-start">Upozornenia</div>
                } @else {
                    <div matListItemTitle i18n>Upozornenia</div>
                }
            </a>
        </mat-nav-list>
    </mat-sidenav>


    <mat-sidenav-content>

        <router-outlet></router-outlet>

        <div *ngIf="message" class="center-screen">
            <i class="fa fa-thumbs-up"></i>
        </div>

    </mat-sidenav-content>

</mat-sidenav-container>

<lib-app-footer [red]="red"></lib-app-footer>
